<template>
  <div class="lessonschedule">
    <top-nav :list="topList"></top-nav>
    <!--<above-nav></above-nav>-->
    <div class="content-wrapper">
      <div class="content">
        <div class="filter-wrapper">
          <el-radio-group v-model="radioSelect">
            <el-radio label="显示近期课程"></el-radio>
            <el-radio label="显示全部"></el-radio>
            <el-radio label="选择时间查找"></el-radio>
          </el-radio-group>
          <template v-if="timepickShow">
            <el-date-picker
              class="timepicker"
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              size="mini">
            </el-date-picker>
            <span class="search" @click="search">查询</span>
          </template>
        </div>
        <div class="list-wrapper">
          <template v-for="(item,index) in list">
            <div class="list">
              <p class="time" :style="{'color':item.endtime?'#999':''}">{{item.planstarttime.substring(5, 10)}}
                {{item.planstarttime.substring(11, 16)}}-{{item.planendtime.substring(11, 16)}}
                <span class="end" v-if="item.endtime">已结束</span>
              </p>
              <p class="name" :style="{'color':item.endtime?'#ccc':''}">
                第{{item.catalog_index}}课
                {{decodeURIComponent(item.catalogname)}}
              </p>
              <p class="type" :style="{'color':item.endtime?'#ccc':''}">
                {{decodeURIComponent(item.classmodename)}}
                -{{decodeURIComponent(item.classname)}}
              </p>
              <button class="btn add" @click="gotoAdd(item)">添加课件</button>
              <button class="btn in" @click="gotoLive(item)">进入直播间</button>
            </div>
          </template>
        </div>
        <template v-if="!isEmpty(list)">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="16"
            :total="totoalPage">
          </el-pagination>
        </template>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
  const TYPE1 = '显示近期课程';
  const TYPE2 = '显示全部';
  const TYPE3 = '选择时间查找';
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav';
  import aboveNav from 'components/abovenav/AboveNav'
  export default{
    data(){
      return {
        id: (() =>  loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        topList: [
          {
            name: 'm.cou_top_bjgl',
            to: '/console/lesson/class',

          },
          {
            name: 'm.cou_top_kjgl',
            to: '/console/lesson/ware',
          },
          {
            name: 'm.cou_top_kcb',
            to: '/console/lesson/schedule',
          },
          {
            name: 'm.cou_top_kcyhq',
            to: '/console/lesson/coupon'
          },
//          {
//            name: '班级预约',
//            to: '/console/lesson/appoint',
//          },
//          {
//            name: '课程评价',
//            to: '/console/lesson/rate',
//          },
        ],
        //-----------以下内容和筛选有关-----------//
        radioSelect: '显示近期课程',
        oldRadioSelect: '显示近期课程',
        timepickShow: false,
        date: [new Date(), new Date()],
        oldDate: [new Date(), new Date()],
        //-----------以下内容和课程表有关-----------//
        list: [],
        currentPage: 1,
        totoalPage: 0,
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //点击添加课件
      gotoAdd(item){
        saveLocal('scheduleinfo',item);
        this.$router.push('/console/lesson/schedule/add')
      },
      //-------------------进入直播间---------------------------//
      gotoLive(item){
        let id=this.id;
        let classid=item.classid;
        let rid=item.rid;
        let lessonid=item.lessonid;
        let catalogindex=item.catalog_index;
        let catalogid=item.id;
        window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //用户打开时间选择后，点击搜索
      search(){
        //如果时间为空，则给予提示
        if (this.date == null) {
          this.$message({
            message: '请输入时间！',
            type: 'waring'
          });
        } else {
          //如果时间不为空，则将oldRadioSelect置为第三种状态，同时oldDate设为date（此种情况可以预防用户选择时间查询后，清空时间，同时点击下一页）
          this.oldRadioSelect = TYPE3;
          this.oldDate = this.date;
          let params = this.conputeXHRParams(1);
          this.currentPage = 1;
          this.loadList(params);
        }
      },
      //根据用户选择的选项，计算XHR请求的参数
      conputeXHRParams(pageNumber){
        let params = {
          c: 'ClassHistory',
          a: 'QueryClassTeacherHistory',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          lessonid: this.lessoninfo.id,
          pageno: pageNumber,
          pagesize: 16,
          count: 1
        };
        //根据old选择的是什么，重新将当前的选择置为old的选择（即如果用户点击了‘显示近期课程’，再点击了‘选择时间查找’，并没有点查询，则用户点击下一页时，应当将单选框重置为‘显示近期课程’）
        this.radioSelect = this.oldRadioSelect;
        if (this.oldRadioSelect === TYPE1) {
          //‘显示近期课程’是需要设置querystartdate参数的
          let date = new Date();
          params.querystartdate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        } else if (this.oldRadioSelect === TYPE3) {
          //如用户选择时间并查找后，清空了时间，同时点击下一步，应当让时间重新置为之前选择的时间
          this.date = this.oldDate;
          let startDate = this.oldDate[0];
          let endDate = this.oldDate[1];
          let start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
          let end = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
          params.querystartdate = start;
          let interval = ( Math.abs(Date.parse(end) - Date.parse(start)) ) / 1000 / 60 / 60 / 24;
          params.querydays = interval + 1;
        }
        return params;
      },
      //获取课程表列表
      loadList(params){
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if(response.code===111){
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.list = response.list;
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //改变页码时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(val);
        this.loadList(params);
        this.$forceUpdate();
      },

    },
    created(){
      //根据conputeXHRParams确定XHR请求的参数，再异步请求数据
      let params = this.conputeXHRParams(1);
      this.loadList(params);
    },
    watch: {
      //根据用户选择单选按钮，做出的操作
      radioSelect(){
        if (this.radioSelect === TYPE3) {
          this.timepickShow = true;
          this.date = this.oldDate;
        } else {
          //隐藏选择时期
          this.timepickShow = false;
          //设置oldoldRadioSelect，请请求数据
          this.oldRadioSelect = this.radioSelect;
          let params = this.conputeXHRParams(1);
          this.currentPage = 1;
          this.loadList(params);
        }
      }
    },
    components: {
      topNav,
      aboveNav
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .lessonschedule
    position fixed
    left: 160px
    top: 91px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    z-index:10
    .content-wrapper
      padding: 20px 0 20px
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left:20px
        padding-bottom: 20px
        width: 1166px
        .filter-wrapper
          padding-left: 15px
          height: 48px
          line-height: 48px
          width: 100%
          background #fff
          box-sizing border-box
          .timepicker
            margin-left: 20px
            position relative
            top: 3px
          .search
            position relative
            top: 4px
            display: inline-block
            margin-left: 10px
            height: 28px
            line-height: 28px
            width: 60px
            text-align: center
            font-size: 14px
            color: #704000
            background #ffcc66
            border-radius 4px
            cursor: pointer

        .list-wrapper
          margin-top: 20px
          .list
            display: inline-block
            padding: 20px 0 0 20px
            width: 284px
            height: 180px
            background #fff
            margin: 0 10px 10px 0
            overflow: hidden
            box-sizing border-box
            cursor pointer
            &:nth-child(4n)
              margin-right: 0
            &:hover .time
              color: #3399ff!important
              margin-bottom: 22px
            &:hover .btn
              display: inline-block
            .time
              margin-bottom: 36px
              font-size: 16px
              color: #000000
              line-height: 22px
              font-weight: bold
              transition-duration 200ms
              .end
                display: inline-block
                margin-left: 6px
                width: 44px
                height: 18px
                line-height 18px
                text-align center
                font-size: 13px
                color: #ffffff
                background #ccc
            .name
              margin: 0 0 14px 0
              font-size: 14px
              color: #666
              line-height: 19px
              overflow hidden
              text-overflow ellipsis
              white-space nowrap
            .type
              margin-bottom: 20px
              font-size: 13px
              color: #666
              line-height: 19px
              overflow hidden
              text-overflow ellipsis
              white-space nowrap
              &:hover
                color: #3399ff!important
            .btn
              display: none
              height: 34px
              line-height: 1
              fnt-size: 15px
              border-radius 4px
              width: 100px
              text-align center
            .add
              margin-left: 4px
              border: 1px solid #d7d7d7
              color: #666
            .in
              margin-left: 36px
              background #3399ff
              color: #fff

</style>



// WEBPACK FOOTER //
// src/page/lesson/lessonschedule/LessonSchedule.vue